import {createSelector} from 'helpers';

export const options = createSelector(
  [ state => state.settings.diary ],
  ( settings ) => ({
    sort: 'newest',
    ...settings
  })
);
